import { apiClient } from './client';
import type { NotificationsResponse } from '@affogato/shared';

export const notificationsApi = {
  async getAll(unreadOnly = false): Promise<NotificationsResponse> {
    const params = unreadOnly ? '?unread=true' : '';
    return apiClient.get(`/notifications${params}`);
  },

  async markAsRead(id: string): Promise<{ success: boolean }> {
    return apiClient.put(`/notifications/${id}/read`, {});
  },

  async markAllAsRead(): Promise<{ success: boolean }> {
    return apiClient.put('/notifications/read-all', {});
  },

  async delete(id: string): Promise<{ success: boolean }> {
    return apiClient.delete(`/notifications/${id}`);
  },

  async clearRead(): Promise<{ success: boolean }> {
    return apiClient.delete('/notifications/clear-read');
  },

  async analyzeProjects(locale: string = 'es'): Promise<{
    alerts: Array<{
      id: string;
      projectId: string;
      alertType: string;
      title: string;
      message: string;
      priority: string;
    }>;
    analyzedProjects: number;
  }> {
    return apiClient.post('/notifications/analyze-projects', { locale });
  },
};
